import NavigationStore from '@app/stores/NavigationStore';
import PermissionsStore from '@app/stores/PermissionsStore';
import GuestLoginStore from './GuestLoginStore';
import UserStore from '@app/stores/UserStore';
import LocaleStore from '@app/stores/LocaleStore';
import InfraStores from '@app/stores/InfraStores';
import HealthCheckStore from '@app/stores/HealthCheckStore';
import ThemeStore from '@app/stores/ThemeStore';
import LanguageStore from '@app/stores/LanguageStore';
import Mode from '@app/modes/Mode';
import { DEFAULT_GUEST_LOGIN_I18N_NAMESPACE, GuestLoginBrandedTheme } from '@app/guestLogin/domain/guestLogin';

export default class GuestInfraStores<
  TNavigationStore extends NavigationStore = NavigationStore,
  TPermissionsStore extends PermissionsStore = PermissionsStore,
  TThemeStore extends ThemeStore = ThemeStore,
> extends InfraStores<TNavigationStore, TPermissionsStore, TThemeStore> {
  guestLoginStore: GuestLoginStore;

  constructor(
    userStore: UserStore,
    languageStore: LanguageStore,
    localeStore: LocaleStore,
    navigationStore: TNavigationStore,
    permissionsStore: TPermissionsStore,
    themeStore: TThemeStore,
    healthCheckStore: HealthCheckStore,
    guestLoginI18nNamespace: string = DEFAULT_GUEST_LOGIN_I18N_NAMESPACE,
  ) {
    super(userStore, languageStore, localeStore, navigationStore, permissionsStore, themeStore, healthCheckStore);

    this.guestLoginStore = new GuestLoginStore(guestLoginI18nNamespace);
  }

  async init(): Promise<void> {
    await super.init();
    await this.guestLoginStore.initAfterAllStoresInitialized();
  }
}

export function isGuestInfraStores(infraStores: InfraStores): infraStores is GuestInfraStores {
  return 'guestLoginStore' in infraStores;
}

// The mode-agnostic host contract guestLogin screens need via useInfraStores/useTheme, so they don't depend on any
// concrete mode (e.g. ArMode). Any mode whose infra stores extend GuestInfraStores and whose theme extends
// GuestLoginBrandedTheme can host these screens.
export type GuestMode = Mode<GuestInfraStores<NavigationStore, PermissionsStore, ThemeStore<GuestLoginBrandedTheme>>>;
